<p-toast />
<div class="layout-centered">
  <p-card styleClass="card-style-account">
    <ng-template pTemplate="header">
      <img src="/assets/images/logo-redcurve.png" id="logo-redcurve" />
    </ng-template>

    <h1 class="h3">Set New Password</h1>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
      <div class="field">
        <div class="p-inputgroup">
          <input pInputText id="newPassword"
                 formControlName="newPassword"
                 [type]="showPassword ? 'text' : 'password'"
                 (input)="validatePassword()" />
          <span class="p-inputgroup-addon cursor" (click)="togglePasswordVisibility()">
            <i class="pi" [ngClass]="{'pi-eye-slash': !showPassword, 'pi-eye': showPassword}"></i>
          </span>
        </div>

        <!-- Password Rules List -->
        <div class="text-sm mt-3">
          <span [ngClass]="{'text-success': passwordValidations.uppercase, 'text-danger': !passwordValidations.uppercase}">
            <i class="pi inline-block mr-2" [ngClass]="{'pi-check': passwordValidations.uppercase, 'pi-times': !passwordValidations.uppercase}"></i>
            At least one uppercase letter (A-Z).
          </span><br>
          <span [ngClass]="{'text-success': passwordValidations.lowercase, 'text-danger': !passwordValidations.lowercase}">
            <i class="pi inline-block mr-2" [ngClass]="{'pi-check': passwordValidations.lowercase, 'pi-times': !passwordValidations.lowercase}"></i>
            At least one lowercase letter (a-z).
          </span><br>
          <span [ngClass]="{'text-success': passwordValidations.number, 'text-danger': !passwordValidations.number}">
            <i class="pi inline-block mr-2" [ngClass]="{'pi-check': passwordValidations.number, 'pi-times': !passwordValidations.number}"></i>
            At least one numeric digit (0-9).
          </span><br>
          <span [ngClass]="{'text-success': passwordValidations.specialChar, 'text-danger': !passwordValidations.specialChar}">
            <i class="pi inline-block mr-2" [ngClass]="{'pi-check': passwordValidations.specialChar, 'pi-times': !passwordValidations.specialChar}"></i>
            At least one special character (e.g., !&#64;#$%^&*).
          </span><br>
          <span [ngClass]="{'text-success': passwordValidations.minLength, 'text-danger': !passwordValidations.minLength}">
            <i class="pi inline-block mr-2" [ngClass]="{'pi-check': passwordValidations.minLength, 'pi-times': !passwordValidations.minLength}"></i>
            At least 8 characters.
          </span>
        </div>
      </div>
      <div class="text-center mt-3">
        <button pButton type="submit" label="Save" [disabled]="resetPasswordForm.invalid"></button>
      </div>
    </form>
  </p-card>

  <div class="centered-footer">
    <span>Copyright &copy; 2025</span> |
    <span>RedCurve Solutions &reg;</span> |
    <span>All Rights Reserved</span>
  </div>
</div>
